import styled from "styled-components";

export const AppSection = styled.div`
  margin-top: 50px;
  margin-bottomg: 50px;
`;
